const Dashboard = () => {
  return (
    <main className="flex gap-8 ">
      <div className="bg-green-100 text-green-700 w-full p-6 rounded-sm">
       Kullanıcı paneline hoşgeldiniz.
      </div>
    </main>
  );
};
export default Dashboard;
